export const NOTEBOOK_GET_ALL_REQUEST = "NOTEBOOK_GET_ALL_REQUEST";
export const NOTEBOOK_GET_ALL_SUCCESS = "NOTEBOOK_GET_ALL_SUCCESS";
export const NOTEBOOK_EDIT = "NOTEBOOK_EDIT";
export const NOTEBOOK_REMOVE = "NOTEBOOK_REMOVE";
export const NOTEBOOK_GET_ALL_FAIL = "NOTEBOOK_GET_ALL_FAIL";

export const NOTEBOOK_GET_ONE_SUCCESS = "NOTEBOOK_GET_ONE_SUCCESS";
